
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Breadcrumbs361832239",
      {"classes":{"root":"Breadcrumbs361832239__root","breadcrumbsHover":"Breadcrumbs361832239__breadcrumbsHover","breadcrumbs":"Breadcrumbs361832239__breadcrumbs","item":"Breadcrumbs361832239__item","itemContainer":"Breadcrumbs361832239__itemContainer","divider":"Breadcrumbs361832239__divider"},"vars":{},"stVars":{"color":"var(--wsr-color-D30, #577083)","backgroundColor":"var(--wsr-color-D80, #FFFFFF)","height":"36px","sidePadding":"14px"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  